/* src/app/shared/dialog/screen-dialog/screen-type/screen-type.component.scss */
.container-type {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  border-radius: 10px;
  background: #FFF;
  width: 500px;
  height: auto;
}
.type-line {
  display: flex;
}
.small-icon-add {
  width: 19px;
  height: 19px;
  font-size: 19px;
  margin-right: 10px;
  color: rgba(107, 144, 179, 0.6);
  cursor: pointer;
}
.small-icon-check {
  width: 19px;
  height: 19px;
  font-size: 19px;
  margin-right: 10px;
  color: #00D78C;
  cursor: pointer;
}
.type-name {
  color: #6B90B3;
  font-size: 400 12px FranceTV Brown;
  padding-top: 3px;
}
.small-icon-arrow {
  width: 22px;
  height: 22px;
  font-size: 22px;
  margin-right: 10px;
  color: #6B90B3;
  position: absolute;
  right: 0;
  top: 15px;
  cursor: pointer;
}
.screen-action-container {
  padding: 25px 10px 0 0;
  display: flex;
  justify-content: end;
}
.list-container-wrapper {
  overflow-y: hidden;
}
.list-container {
  overflow-y: auto;
  height: 350px;
}
.container-route-name {
  display: flex;
  flex-direction: row;
}
.icon-back {
  color: #244666;
  cursor: pointer;
  width: 45px;
  height: 35px;
  font-size: 37px;
}
.route-name {
  color: #F03C64;
  font-size: 400 12px FranceTV Brown;
  padding-top: 12px;
}
.select-action {
  background-color: white;
  border: none;
}
.search-wrapper {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
/*# sourceMappingURL=screen-type.component.css.map */
